import { useWindowSize } from './useWindowSize'
export const useMobile = () => {
  const size = useWindowSize()
  return Number(size.width) <= 960
}

export default useMobile
